import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SiteArmEditComponent } from './site-arm-edit.component';
import { WarningModule } from '../warning/warning.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SharedModule } from '../../directives/shared.module';
import { c_alert_module } from '../../../3ui/2components/alert/c_alert_module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WarningModule,
    NgxSliderModule,
    SharedModule,
    c_alert_module,
  ],
  declarations: [SiteArmEditComponent],
  exports: [ SiteArmEditComponent ]
})
export class SiteArmEditModule { }
